import '../common/base';
import Vue from '../common/vue-common';
import ProductPage from '../../submodules/src/componentsV2/product/ProductPage.vue';
import RenderNotifier from '../components/common/RenderNotifier';
import product from '../../submodules/src/script/i18n/product';
import shop from '../../submodules/src/script/i18n/shop';
import marketing from '../../submodules/src/script/i18n/marketing';
import general from '../../submodules/src/script/i18n/general';
import locale from '../../submodules/src/script/i18n/locale';
import gallery from '../../submodules/src/script/i18n/gallery';
import ProductRelated from '../components/product/ProductRelated.vue';
import { lazyLoadInstance } from '../../submodules/src/script/lazyload';

new Vue({
    el: '#product-vue',
    i18n: locale(general(), shop(), product(), gallery(), marketing()),
    data() {
        return {
            shirtsSliderOptions: {
                slidesPerView: 2,
                fitSlidesToParent: true,
                onNavigate: () => lazyLoadInstance.update(),
                responsive: [
                    {
                        minWidth: 565,
                        settings: {
                            slidesPerView: 3,
                        },
                    },
                    {
                        minWidth: 960,
                        settings: {
                            slidesPerView: 5,
                        },
                    },
                ],
            },
        };
    },
    components: {
        'render-notifier': RenderNotifier,
        'product-page': ProductPage,
        'product-related': ProductRelated,
    },
});
